import { IFrameMessageSender, MessageType, NavigatedMessage, UpdateBreadcrumbsMessage, useMessageReceiver } from '@farmasiet/iframe-messages';
import { useState } from 'react';
import React from 'react';

import { Breadcrumb, Breadcrumbs } from './Breadcrumbs';
import { BreadcrumbsViewModel } from './BreadcrumbsViewModel.csharp';

interface IframeBreadcrumbsProps extends BreadcrumbsViewModel {
    currentPageUrl: string;
    messageSender: IFrameMessageSender;
}

export const IframeBreadcrumbs = (props: IframeBreadcrumbsProps) => {
    const currentPageBreadcrumb: Breadcrumb = { text: props.currentPageName, href: props.currentPageUrl, onClick: () => onBreadcrumbClick('/') };
    const staticBreadcrumbs: Breadcrumb[] = props.elements.map((element) => ({ text: element.text, href: element.href }));
    const [dynamicBreadcrumbs, setDynamicBreadcrumbs] = useState<Breadcrumb[]>([]);

    useMessageReceiver(props.philUrl, MessageType.UPDATE_BREADCRUMBS, (message: UpdateBreadcrumbsMessage) => {
        setDynamicBreadcrumbs(
            message.breadcrumbs.map((breadcrumb) => {
                const url = new URL(window.location.href);
                url.searchParams.set('path', breadcrumb.href);

                return { text: breadcrumb.text, href: url.href, onClick: () => onBreadcrumbClick(breadcrumb.href) };
            })
        );
    });

    const onBreadcrumbClick = (path: string) => props.messageSender.sendMessage(new NavigatedMessage(path));

    return <Breadcrumbs style={props.style} breadcrumbs={[...staticBreadcrumbs, currentPageBreadcrumb, ...dynamicBreadcrumbs]} />;
};
